// Page Connecteurs (22/10, Louka) : dans les trois apps assistant, la page « Outils » de l'espace
// système faisait doublon avec « Connecteurs » (les mêmes Gmail, Google Agenda, Google Drive et
// Service public, réglables à deux endroits). Elle sort du menu ; son adresse reste joignable pour
// l'équipe. Le produit de compta (sans marque ou autre marque) garde son menu.
import { estMarqueAssistant } from "@app/lib/compta/filtres";

/**
 * La page Connecteurs de chacun (22/10) : un membre y connecte ses comptes, un administrateur y est
 * renvoyé vers la page de l'espace système (sources de documents comprises).
 */
export function routeConnecteurs(workspaceId: string): string {
  return `/w/${workspaceId}/connecteurs`;
}

/** Si l'entrée « Outils » de l'espace système figure au menu pour la marque de la SPA. */
export function outilsAuMenu(
  marque: string | undefined = process.env.NEXT_PUBLIC_MARQUE
): boolean {
  return !estMarqueAssistant(marque);
}
